module.exports = __webpack_public_path__ + "img/group.014004ed.png";